import { Component, input, signal, effect, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { Subscription } from 'rxjs';
import { FormMode } from 'app/core/constants/form-mode';
import { renderMarkdown } from '../../utils/markdown.util';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-help-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgSelectModule],
  templateUrl: './help-form.component.html',
  styleUrl: './help-form.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class HelpFormComponent implements OnDestroy {
  helpForm = input.required<FormGroup>();
  mode = input<FormMode>(FormMode.CREATE);
  routeOptions = input<{ label: string; value: string }[]>([]);

  formMode = FormMode;
  previewHtml = signal<SafeHtml>('');
  contentTab = signal<'edit' | 'preview' | 'split' | 'captures'>('edit');

  audiences = [
    { value: 'BOTH', label: 'Todos' },
    { value: 'OPERATOR', label: 'Operador' },
    { value: 'ADMIN', label: 'Admin / configuración' }
  ];

  private sanitizer = inject(DomSanitizer);
  private sub?: Subscription;

  constructor() {
    effect(() => {
      const form = this.helpForm();
      this.sub?.unsubscribe();
      if (!form) return;
      const refresh = () => {
        const html = renderMarkdown(form.get('bodyMd')?.value);
        this.previewHtml.set(this.sanitizer.bypassSecurityTrustHtml(html));
      };
      refresh();
      this.sub = form.get('bodyMd')?.valueChanges.subscribe(() => refresh());
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
